export enum VehicleType {
  CAR = "Car",
  CARAVAN = "Caravan",
  MOTORCYCLE = "Motorcycle",
  MOTORHOME = "Motorhome",
  BLANK = "-",
}

type VehicleTypes = `${VehicleType}`;

export default VehicleTypes;
